export enum StorageKeyEnum {
  LogisticBoxViewData = "LogisticBoxViewData",
  User = "User",
  InvItemCols = "InvItemCols",
  InvSkuCols = "InvSkuCols",
  InvVendorCols = "InvVendorCols",
  DatavancedDetails = "DatavancedDetails",
  PricingFba = "PricingFba",
  ShipmentFilter = "ShipmentFilter",
  Dimensions = "Dimensions",

  // Inventory
  AgGridInventorySkus = "AgGridInventorySkus",
  AgGridInventorySkusWalmart = "AgGridInventorySkusWalmart",
  AgGridInventoryProducts = "AgGridInventoryProducts",
  AgGridInventoryItems = "AgGridInventoryItems",
  AgGridInventoryVendors = "AgGridInventoryVendors",

  // Planyard
  AgGridPlanyardPurchasing = "AgGridPlanyardPurchasing",
  AgGridPurchasingSubGrid = "AgGridPurchasingSubGrid",
  AgGridPlanyardReplenish = "AgGridPlanyardReplenish",
  AgGridPlanyardReplenishWalmart =  "AgGridPlanyardReplenishWalmart",
  AgGridPlanyardOrders = "AgGridPlanyardOrders",
  AgGridPurchasingBySku='AgGridPurchasingBySku',
  AgGridFbmOrders= 'AgGridFbmOrders',
  AgGridPurchaseOrderDetailGrid = "AgGridPurchaseOrderDetailGrid",

  // Priceyard
  AgGridPriceyard = "AgGridPriceyard",
  AgGridPriceyardHistory = "AgGridPriceyardHistory",
  AgGridPriceyardSellers = "AgGridPriceyardSellers",

  // Warehouse
  AgGridWhLocation = "AgGridWhLocation",
  AgGridWhHistory = "AgGridWhHistory",


  // Analytics
  AgGridAnalyticsDate = "AgGridAnalyticsDate",
  AgGridAnalyticsSku = "AgGridAnalyticsSku",
  AgGridStockHolding = "AgGridStockHolding",
  AgGridKpiSales = "AgGridKpiSales",
  AgGridKpiProfit = "AgGridKpiProfit",
  AgGridKpiRoi = "AgGridKpiRoi",
  AgGridKpiStockHolding = "AgGridKpiStockHolding",
  AgGridKpiOverStocked = "AgGridKpiOverStocked",
  AgGridKpiPpcSpent = 'AgGridKpiPpcSpent',
  AgGridKpiRestockNow = 'AgGridKpiRestockNow',
  AgGridOutOfStock = 'AgGridOutOfStock',
  AgGridInventorySummary="AgGridInventorySummary",
  AgGridPoSummary = "AgGridPoSummary",
  AgGridCostDetails = "AgGridCostDetails",
  SelectedAccount = "SelectedAccount",
  MonthlyPrice = "MonthlyPrice",
  ProductsSubGridType = "ProductsSubGridType",
  Summary = "Summary",
  AccountIntegrationName = "AccountIntegrationName",
  AccountIntegrationMarketplace = "AccountIntegrationMarketplace",
  selectedTab = "selectedTab",
  AccountIntegrationMarketplaceRegionalId = "AccountIntegrationMarketplaceRegionalId",
  SelectedAccountType = "SelectedAccountType",
  // Purchase Order List Filter Storage
  PoFilters = "PoFilters",
  KPIFilters = "KPIFilters",
  ShipmentTableView = 'ShipmentTableView',
  
  // Filter keys for grid
  // Inventory
  AgGridFilterInventorySkus = "AgGridFilterInventorySkus",

  AccountFilters="AccountFilters",
  AllAccounts="Accounts"

}
